import { render, staticRenderFns } from "./h5Index.vue?vue&type=template&id=f283f7b6&scoped=true&"
import script from "./h5Index.vue?vue&type=script&lang=js&"
export * from "./h5Index.vue?vue&type=script&lang=js&"
import style0 from "./h5Index.vue?vue&type=style&index=0&id=f283f7b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f283f7b6",
  null
  
)

export default component.exports